import { EntityDocumentsOrderBy } from 'common/types/globalTypes';
import { OrderDirection, SortOrder } from './types';
import { OrderLookup } from 'common/utils/commonTypes';

const orderByMap = new Map<string, OrderLookup>([
  [
    '_documentPoolName',
    {
      [OrderDirection.ASC]: ['_DOCUMENT_POOL_NAME_ASC'],
      [OrderDirection.DESC]: ['_DOCUMENT_POOL_NAME_DESC'],
    },
  ],
  [
    'indexName',
    {
      [OrderDirection.ASC]: ['INDEX_NAME_ASC'],
      [OrderDirection.DESC]: ['INDEX_NAME_DESC'],
    },
  ],
  [
    'indexReferenceNumber',
    {
      [OrderDirection.ASC]: ['INDEX_REFERENCE_NUMBER_ASC'],
      [OrderDirection.DESC]: ['INDEX_REFERENCE_NUMBER_DESC'],
    },
  ],
  [
    '_documentContents',
    {
      [OrderDirection.ASC]: ['_DOCUMENT_CONTENTS_ASC'],
      [OrderDirection.DESC]: ['_DOCUMENT_CONTENTS_DESC'],
    },
  ],
  [
    'fileReference',
    {
      [OrderDirection.ASC]: ['_FILE_NAME_ASC'],
      [OrderDirection.DESC]: ['_FILE_NAME_DESC'],
    },
  ],
  [
    'indexTransactionDate',
    {
      [OrderDirection.ASC]: ['INDEX_TRANSACTION_DATE_ASC'],
      [OrderDirection.DESC]: ['INDEX_TRANSACTION_DATE_DESC'],
    },
  ],
  [
    '_uploadDate',
    {
      [OrderDirection.ASC]: ['_UPLOAD_DATE_ASC'],
      [OrderDirection.DESC]: ['_UPLOAD_DATE_DESC'],
    },
  ],
  [
    'indexAmount',
    {
      [OrderDirection.ASC]: ['INDEX_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['INDEX_AMOUNT_DESC'],
    },
  ],
  [
    'available',
    {
      [OrderDirection.ASC]: ['INDEX_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['INDEX_AMOUNT_DESC'],
    },
  ],

  [
    'isoCode',
    {
      [OrderDirection.ASC]: [
        'COMPANY_CURRENCY_BY_INDEX_CURRENCY_ID__ISO_CODE_ASC',
      ],
      [OrderDirection.DESC]: [
        'COMPANY_CURRENCY_BY_INDEX_CURRENCY_ID__ISO_CODE_DESC',
      ],
    },
  ],
  [
    'documentAppliedAmount',
    {
      [OrderDirection.ASC]: ['DOCUMENT_APPLIED_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['DOCUMENT_APPLIED_AMOUNT_DESC'],
    },
  ],
  [
    'Comment',
    {
      [OrderDirection.ASC]: ['COMMENT_ASC'],
      [OrderDirection.DESC]: ['COMMENT_DESC'],
    },
  ],
  [
    '_uploadDate',
    {
      [OrderDirection.ASC]: ['_UPLOAD_DATE_ASC'],
      [OrderDirection.DESC]: ['_UPLOAD_DATE_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: EntityDocumentsOrderBy[] = [
    '_UPLOAD_DATE_DESC',
    'PRIMARY_KEY_DESC',
  ];
  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ? orderBy : []), ...orderByArray];
};
